import { Button, Col, Form, Row, Upload } from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { InitialData } from "../../common/InitialData";
import { Formik } from "formik";
import FileUploadWithThumbnails from "./FileUploadWithThumbnails";
import { IMAGE_BASE_URL } from "../../common/Constants";

const VehicleDocuments = ({ updateFunction, filterData, vehicleDocumnets }) => {
    const loalVehicleDocuments = JSON.parse(localStorage.getItem("vehicleDocuments"));
    const [vehicelDocuments, setVehicleDocuments] = useState({});
    const [vehicleLoanTypeData, setVehicleLoanTypeData] = useState("");

    const GetFilesFormatted = (files) => {
        return files?.length > 0
            ? files?.map((url, idx) => {
                return {
                    uid: idx + 1,
                    name: url.name ? url.name : "Document",
                    status: "done",
                    url: `${IMAGE_BASE_URL}${url.value}`,
                };
            })
            : [];
    };

    useEffect(() => {
        const VehicleLoanType = filterData;
        if (VehicleLoanType.category == "f96b81ae-7210-4332-80d2-070556ea724b") {
            setVehicleDocuments(InitialData.vehicle_documents_new);
        } else {
            setVehicleDocuments(InitialData.vehicle_documents);
        }
        setVehicleLoanTypeData(VehicleLoanType.category);
    }, []);
    useEffect(() => {
        if (
            vehicleDocumnets !== undefined &&
            vehicleDocumnets !== null &&
            Object.keys(vehicleDocumnets)?.length > 0
        ) {
            setVehicleDocuments(vehicleDocumnets);
        } else {
            if (loalVehicleDocuments !== undefined && loalVehicleDocuments !== null && Object.keys(loalVehicleDocuments)?.length > 0) {
                setVehicleDocuments(loalVehicleDocuments);
            }
        }
    }, [vehicleDocumnets]);
    return (
        <div>
            <Formik
                initialValues={vehicelDocuments}
                onSubmit={(values, { setSubmitting }) => { }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <Form layout="vertical" onSubmit={handleSubmit}>
                        {vehicleLoanTypeData != "f96b81ae-7210-4332-80d2-070556ea724b" && (
                            <Row gutter={[16, 16]}>
                                <FileUploadWithThumbnails
                                    label={"Logcard"}
                                    maxfile={2}
                                    size={6}
                                    datakey={"vehicle_details"}
                                    dataApiKey={"log_card"}
                                    updateFunction={updateFunction}
                                    files={GetFilesFormatted(vehicelDocuments?.log_card)}
                                />
                                <FileUploadWithThumbnails
                                    label={"Sales Agreement"}
                                    maxfile={2}
                                    size={6}
                                    datakey={"vehicle_details"}
                                    dataApiKey={"sale_agreement"}
                                    updateFunction={updateFunction}
                                    files={GetFilesFormatted(vehicelDocuments?.sale_agreement)}
                                />
                                <FileUploadWithThumbnails
                                    label={"Additional Documents"}
                                    maxfile={6}
                                    size={8}
                                    datakey={"vehicle_details"}
                                    dataApiKey={"additional_documents"}
                                    updateFunction={updateFunction}
                                    files={GetFilesFormatted(vehicelDocuments?.additional_documents)}
                                />
                            </Row>
                        )}
                        {vehicleLoanTypeData == "f96b81ae-7210-4332-80d2-070556ea724b" && (
                            <Fragment>
                                <Row gutter={[16, 16]}>
                                    <FileUploadWithThumbnails
                                        label={"V5/Overseas Logcard"}
                                        maxfile={2}
                                        size={6}
                                        datakey={"vehicle_details"}
                                        dataApiKey={"vehicle_overseas_log_card"}
                                        updateFunction={updateFunction}
                                        files={GetFilesFormatted(vehicelDocuments?.vehicle_overseas_log_card)}
                                    />
                                    <FileUploadWithThumbnails
                                        label={"Sales Agreement"}
                                        maxfile={2}
                                        size={6}
                                        datakey={"vehicle_details"}
                                        dataApiKey={"sale_agreement"}
                                        updateFunction={updateFunction}
                                        files={GetFilesFormatted(vehicelDocuments?.sale_agreement)}
                                    />
                                    <FileUploadWithThumbnails
                                        label={"Datacard"}
                                        maxfile={6}
                                        size={8}
                                        datakey={"vehicle_details"}
                                        dataApiKey={"data_card"}
                                        updateFunction={updateFunction}
                                        files={GetFilesFormatted(vehicelDocuments?.data_card)}
                                    />
                                </Row>
                                <Row gutter={[16, 16]}>
                                    <FileUploadWithThumbnails
                                        label={"Cargo Clearance Permit:"}
                                        maxfile={2}
                                        size={6}
                                        datakey={"vehicle_details"}
                                        dataApiKey={"cargo_clearance_permits"}
                                        updateFunction={updateFunction}
                                        files={GetFilesFormatted(vehicelDocuments?.cargo_clearance_permits)}
                                    />
                                    <FileUploadWithThumbnails
                                        label={"Bill of Lading (BL): "}
                                        maxfile={2}
                                        size={6}
                                        datakey={"vehicle_details"}
                                        dataApiKey={"bill_of_lading"}
                                        updateFunction={updateFunction}
                                        files={GetFilesFormatted(vehicelDocuments?.bill_of_lading)}
                                    />
                                    <FileUploadWithThumbnails
                                        label={"Letter of Newness: "}
                                        maxfile={6}
                                        size={8}
                                        datakey={"vehicle_details"}
                                        dataApiKey={"letter_of_newness"}
                                        updateFunction={updateFunction}
                                        files={GetFilesFormatted(vehicelDocuments?.letter_of_newness)}
                                    />
                                </Row>
                                <Row gutter={[16, 16]}>
                                    <FileUploadWithThumbnails
                                        label={"Additional Documents"}
                                        maxfile={6}
                                        size={8}
                                        datakey={"vehicle_details"}
                                        dataApiKey={"additional_documents"}
                                        updateFunction={updateFunction}
                                        files={GetFilesFormatted(vehicelDocuments?.additional_documents)}
                                    />
                                </Row>
                            </Fragment>
                        )}
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default VehicleDocuments;
